/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import React, { Component , createRef } from 'react';
import { Image, Spinner } from 'react-bootstrap';
import GatewayWorkflowModal from './GatewayWorkflowModal';
import HelpModal from './HelpModal';
import HomeService from "../../services/home.service";
import AssetService from "../../services/asset.service";
import DeviceService from "../../services/device.service";
import ProvisioningService from "../../services/provisioning.service";
import ProvisioningStatusHistory from "./ProvisioningStatusHistory";

import memoize from "memoize-one";
import moment from 'moment';

import { jsAsset, jsDevice, jsHouse } from "../../componentObjects";
import { PageView, Event, Timing, ModalView } from "../GoogleAnalytics";
import installService from "../../services/install.service";
import Loader from "../Loader/Loader";
import FullLoader from "../Loader/FullLoader";
import CircleIcon from "@mui/icons-material/FiberManualRecord";

const provisionPost = {
    homeList: [],
    assetList: [],
    hvacList: [] 
}
const defaultpage = 1;
const defaultpageCount = 100;

const FLYCATCHER_GATEWAY_TYPE_ID = 2;
const LifePulseT10 = "LifePulseT10";

class Provisioning extends Component {
    static displayName = Provisioning.name;
    _isMounted = false;

    constructor(props) {
        super(props);
        this.inputRef = createRef();
        this.deviceSelectErrorRef = createRef();
        
        this.showGatewayModal = this.showGatewayModal.bind(this);
        this.openGatewayModal = this.openGatewayModal.bind(this);

        this.showHelpModal = this.showHelpModal.bind(this);
        this.openHelpModal = this.openHelpModal.bind(this);

        this.onHVACSelect = this.onHVACSelect.bind(this);
        this.onDeviceSelect = this.onDeviceSelect.bind(this);
        this.onUnparentedAssetSelect = this.onUnparentedAssetSelect.bind(this);
        this.changeRadio = this.changeRadio.bind(this);
        this.populateHomeData = this.populateHomeData.bind(this);
        this.populate = this.populate.bind(this);

        this.runProvisionTest = this.runProvisionTest.bind(this);
        this.provisioningHistoryStatus = this.provisioningHistoryStatus.bind(this);
        this.onChangeadHocMacId = this.onChangeadHocMacId.bind(this);

        this.checkIfFlycatcher = this.checkIfFlycatcher.bind(this);
      
        this.state = {

            provision: provisionPost,

            deviceList: [],
            homeList: [],
            hvacList: [],
            assetList: [],

            loading: false,
            currentHVACSystem: jsHouse,
            currentHome: jsHouse,
            currentDevice: jsAsset,
            currentInstall: {},
            currentInstallTechStr: "",
            unparentedAsset: jsAsset,            
            unparentedAssets: [],
            deviceProvisioningSteps: [],
            failedSteps: [],
            stepsLoading: false,
            showHelp: false,
            showAddUnparentedAsset: false,
            statusMessage: null,
            showStatusMessage: null,
            radio: 0,
            isDisabled: true,
            fixLoading: false,
            provisioningHistoryStatus :{},
            defaultpage : defaultpage,
            adHocMacId : "",
            isFlyCatcherInstall: false,
            isFlyCatcher: false
        };
    }

    componentDidMount() {
        this._isMounted = true;
        PageView();
        this.populateHomeData();
        this.provisioningHistoryStatus(defaultpage, defaultpageCount);
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentCustomerId !== this.props.currentCustomerId) {
            this.populateHomeData();
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    memHomeData = memoize(this.populateHomeDataNew);

    async provisioningHistoryStatus(pageNumber, pageCount)
    {
        await ProvisioningService.getProvisionHistoryStatus(pageNumber ,pageCount)
            .then(response => {
                if (this._isMounted) {
                    this.setState({provisioningHistoryStatus : response.data , defaultpage : pageNumber});
                }
            });
    }

    async populate(id) {
        var startTime = performance.now();
        await HomeService.get(id, this.props.currentPartnerId).then(response => {
            if (this._isMounted) {
                let houseList = response?.data?.map(item => {
                    return { ...item, orgId: item.orgId.toString() };
                });
                this.setState({
                    homeList: houseList,
                    currentHome: response.data !== null && response.data !== undefined && response.data.length ? response.data[0] : jsHouse
                }, async () => {
                    if (this.state.currentHome !== undefined && this.state.currentHome != null) {

                        await AssetService.gethvacassets(this.state.currentHome.assetId).then(response => {
                            if (this._isMounted)
                                this.setState({
                                    hvacList: response.data,
                                    currentHVACSystem: response.data !== null && response.data !== undefined && response.data.length ? response.data[0] : jsHouse
                                }, async () => {
                                    // set a selected hvac system, then get the list of each asset for that system.. just like for home, 

                                    if (this.state.currentHVACSystem !== undefined && this.state.currentHVACSystem !== null) {
                                        await AssetService.get(this.state.currentHVACSystem.assetId).then(response2 => {
                                            if (this._isMounted)
                                                this.setState({
                                                    assetList: response2.data,
                                                    currentAsset: response2.data !== null && response2.data !== undefined && response2.data.length ? response2.data[0] : jsAsset
                                                }, async () => {
                                                    var macId = this.getMacId(this.state.assetList);
                                                    await installService.getinstallbymacid(macId).then(response2 => {
                                                        let install = response2;
                                                        if (install !== null && install !== undefined) {
                                                            let techStr = install.technicianName !== null && install.technicianName !== undefined ? install.technicianName + " (" + install.technicianEmail + ") " + moment(install.startDateTime).format("MM/DD/YYYY hh:mm a") : "";
                                                            this.setState({
                                                                currentInstall: install, currentInstallTechStr: techStr
                                                            }, () => {
                                                                let isFlyCatcher = false;
                                                                if (this.state.currentInstall !== null && this.state.currentInstall !== undefined && this.state.currentInstall.gatewayTypeId !== null && this.state.currentInstall.gatewayTypeId === FLYCATCHER_GATEWAY_TYPE_ID) {
                                                                    isFlyCatcher = true;
                                                                }
                                                                this.setState({ isFlyCatcherInstall: isFlyCatcher });
                                                            });
                                                        }
                                                    });

                                                    await DeviceService.get(this.state.assetList)
                                                        .then(response => {
                                                            if (this._isMounted)
                                                                this.setState({
                                                                    deviceList: response.data,
                                                                    currentDevice: response.data !== null && response.data !== undefined && response.data.length ? response.data[0] : jsDevice
                                                                }, async () => {
                                                                    this.setState(prevState => ({
                                                                        provision: {
                                                                            ...prevState.provision,
                                                                            homeList: this.state.homeList,
                                                                            assetList: this.state.assetList,
                                                                            hvacList: this.state.hvacList
                                                                        }
                                                                    }), async () => {
                                                                        if (this.state.currentDevice != null && this.state.currentDevice !== undefined && this.state.currentAsset.assetId !== undefined) {

                                                                            await AssetService.getunparented()
                                                                                .then(response => {
                                                                                    if (this._isMounted)
                                                                                        this.setState({
                                                                                            loading: false,
                                                                                            unparentedAssets: response.data,
                                                                                            unparentedAsset: response.data !== null && response.data !== undefined && response.data.length ? response.data[0] : jsAsset
                                                                                        });
                                                                                }).catch(e => {
                                                                                    console.log(e);
                                                                                });
                                                                        } else {
                                                                            this.setState({loading: false});
                                                                        }
                                                                    });

                                                                })
                                                        });
                                                    //});                                                    
                                                });
                                        });
                                    } else {
                                        this.setState({loading: false}, () => {
                                            var elapsedTime = performance.now() - startTime;
                                            Timing("Devices Loading", "loading", elapsedTime, "Customer Devices Loading");
                                        });
                                    }

                                });
                        });
                    }
                });
            }
        });
    }

    populateHomeData() {
        this.setState({ loading: true }, async () => {
            await this.populate(this.props.currentCustomerId);
        })
    }

    async populateHomeDataNew(propId) {
        this.populate(propId);
    }

    getMacId(assets) {
        if (assets !== null && assets !== undefined && assets.length) {
            if (assets.length > 1) {
                if (assets.filter(a => a.type.trim() !== "Thermostat").length)
                    return assets.filter(a => a.type.trim() !== "Thermostat")[0].mac;
            }
            else
                return assets[0].mac;
        }
    }

    async changeRadio(id) {
        var startTime = performance.now();
        this.deviceSelectErrorRef.current.textContent = '';
        Event("Provisioning Radio Clicked", "User clicked a radio button in provisioning screen", "Provisioning Radio Clicked");
        this.setState({ radio: id, stepsLoading: false });
    }

    onHVACSelect(e) {
        var startTime = performance.now();
        Event("Customer HVAC System Selected", "User selected one of the customers HVAC systems in dropdown", "Customer HVAC System Selected");
        this.setState({
            currentHVACSystem: this.state.hvacList[e.target.value], stepsLoading: true
        }, async () => {

            // set a selected hvac system, then get the list of each asset for that system.. just like for home
            await AssetService.get(this.state.currentHVACSystem.assetId).then(response2 => {
                if (this._isMounted)
                    this.setState({ assetList: response2.data, currentAsset: response2.data !== null && response2.data !== undefined && response2.data.length ? response2.data[0] : jsAsset }, async () => {
                        var macId = this.getMacId(this.state.assetList);
                        await installService.getinstallbymacid(macId).then(response2 => {
                            let install = response2;
                            if (install !== null && install !== undefined) {
                                let techStr = install.technicianName !== null && install.technicianName !== undefined ? install.technicianName + " (" + install.technicianEmail + ") " + moment(install.startDateTime).format("MM/DD/YYYY hh:mm a") : "";
                                this.setState({
                                    currentInstall: install, currentInstallTechStr: techStr
                                }, () => {
                                    let isFlyCatcher = false;
                                    if (this.state.currentInstall !== null && this.state.currentInstall !== undefined && this.state.currentInstall.gatewayTypeId !== null && this.state.currentInstall.gatewayTypeId === FLYCATCHER_GATEWAY_TYPE_ID) {
                                        isFlyCatcher = true;
                                    }
                                    this.setState({ isFlyCatcherInstall: isFlyCatcher });
                                });
                            }
                        });

                        await DeviceService.get(this.state.assetList)
                            .then(response => {
                                if (this._isMounted)
                                    this.setState({ deviceList: response.data }, () => {
                                        this.setState({ currentDevice: this.state.deviceList !== null && this.state.deviceList !== undefined && this.state.deviceList.length ? this.state.deviceList[0] : jsDevice, stepsLoading: false });
                                    })
                            });
                    });
            });

        });
    }

    onDeviceSelect(e) {
        var startTime = performance.now();
        Event("Provisioning Device Selected", "User selected new device to provision", "Provisioning Device Selected");
        this.setState({
            currentDevice: this.state.deviceList[e.target.value], stepsLoading: false, currentAsset: this.state.assetList[e.target.value]
        });
    }

    onUnparentedAssetSelect(e) {
        var startTime = performance.now();
        Event("Provisioning Unparented Selected", "User selected an unparented asset to provision", "Provisioning Unparented Asset Selected");
        this.setState({
            unparentedAsset: this.state.unparentedAssets[e.target.value], stepsLoading: false 
        });
    }

    showGatewayModal = e => {
        this.setState({
            showGateway: !this.state.showGateway
        }, () => {
                if (this.state.showGateway)
                    ModalView("gatewayWorkflow");
        });
        window.scrollTo(0, 0);
    }

    openGatewayModal() {
        Event("Open Gateway Workflow Clicked", "User clicked open gateway workflow button", "Open Gateway Workflow Clicked");
        this.showGatewayModal(null);
    }


    onChangeadHocMacId(e) {
        let macId = e.target.value;

        this.setState({
            adHocMacId: macId
        });
    }

    async checkIfFlycatcher(assetId) {
        let isT10 = false;
        let currentRadio = this.state.radio;
        if (currentRadio === 0 && this.state.isFlyCatcherInstall) {
            isT10 = true;
        }
        else {
            await AssetService.getappliedtags(assetId)
                .then(response => {
                    if (response.status === 200 && response.data !== null && response.data !== undefined && response.data.some(t => t.name === LifePulseT10)) {
                        isT10 = true;
                    }
                    else {
                        isT10 = false;
                    }
                })
                .catch(e => {
                    console.log(e);
                    isT10 = false;
                });
        }
        return isT10;
    }

   async  runProvisionTest(e)
    {
        Event("Run Provision Test Clicked", "User clicked open Provision Test button", "Provision Test Clicked");
        let startTime = performance.now();
        let macId ;
        let assetId ;
        let selectedDeviceType= this.state.radio;
        let runTest = false;
        let macIdPattern = false;
        switch (selectedDeviceType) {
            case 0:
                macId = this.state.currentDevice.mac;
                assetId = this.state.currentAsset.assetId
                runTest = true;
              break;
            case 1:
                macId = this.state.unparentedAsset.name;
                assetId = this.state.unparentedAsset.assetId;
                runTest = true;
                break;
           case 2:
                macId = this.state.adHocMacId;
               let pattern =  /^[a-fA-F0-9]{12}-\d-\d$/;

              if(pattern.test(macId)) 
              {
                  let deviceStatus = await ProvisioningService.getDeviceStatus(macId);
                  if (deviceStatus != null && deviceStatus.data != null && deviceStatus.data != "" && deviceStatus.data.assetId !== null && deviceStatus.data.assetId !== undefined && deviceStatus.data.assetId > 0) {
                      {
                          assetId = deviceStatus.data.assetId;
                          runTest = true;
                      }
                  }
                  else
                  {
                      macIdPattern = true;
                  }
              }
               else
              {
                   macIdPattern = true;
              }
               break ;
        }
        
        let isFlyCatcher = await this.checkIfFlycatcher(assetId);
        
        this.setState({ isFlyCatcher: isFlyCatcher }, async () => {
            if(macId !== undefined && macId !== "" && assetId !== undefined && assetId !== 0  && runTest && !macIdPattern){
                this.deviceSelectErrorRef.current.textContent = '';
                this.setState({  stepsLoading: true} , async () => {
                    await ProvisioningService.get(macId, this.props.currentCustomerId, assetId, this.state.isFlyCatcher, {
                        homeList: this.state.homeList,
                        assetList: this.state.assetList,
                        hvacList: this.state.hvacList
                    })
                        .then(response => {

                            this.setState({
                                deviceProvisioningSteps: response.data !== null && response.data !== undefined ? response.data.steps : [],
                                failedSteps: response.data !== null && response.data !== undefined ? response.data.failedSteps : [],
                                stepsLoading: false
                            }, () => {
                                this.provisioningHistoryStatus(defaultpage, defaultpageCount);
                                var elapsedTime = performance.now() - startTime;
                                Timing("Provisioning Steps Loading", "stepsLoading", elapsedTime, "Provisioning Steps Loading");
                            });
                        })
                        .catch(e => {
                            console.log(e);
                        });
                });
            }
            else
            {
                this.deviceSelectErrorRef.current.textContent = macIdPattern ? 'Invalid MAC ID or Please use XXXXXXXXXXXX-0-0 format': 'Deviceid is required';
                this.deviceSelectErrorRef.current.style.color = 'red';
            }
        });
    }

    showHelpModal = e => {
        this.setState({
            showHelp: !this.state.showHelp,
        }, () => {
                if (this.state.showHelp)
                    ModalView("provisioningFix");
        });
        window.scrollTo(0, 0);
    }

    setupModal(fixTitle, fixMessage) {
        var startTime = performance.now();
        this.setState({ ModalTitle: fixTitle, ModalMessage: fixMessage, fixLoading: false }, () => {
            this.showHelpModal(null);
            var elapsedTime = performance.now() - startTime;
            Timing("Fix Modal Loading", "fixLoading", elapsedTime, "Fix Modal Loading");
            });
    }
      

    async openHelpModal(fixTitle, fixMessage) {
        Event("Fix Clicked", "User clicked fix button", "Fix Clicked");
        this.setState({ fixLoading: true });

        this.setupModal(fixTitle, fixMessage);
    }
    
    renderAssets(homeList, unparentedAssets, deviceList, currentId) {
        const { classes } = this.props;

        let fixContents = this.state.fixLoading ?
            (this.props.isModal ? <FullLoader/> : <Loader />)
            : <div>{null}</div>
        
        let tableContents = this.state.stepsLoading ?
            (this.props.isModal ? <FullLoader/> : <Loader />)
                : <div>
                <table className="table table-striped table-bordered table-sm" aria-labelledby="tableLabel" >
                    <thead>
                        <tr>
                            <th>Step #</th>
                            <th>Status</th>
                            <th>Provisioning Step</th>
                            <th>Description</th>
                            <th>Action</th>
                        </tr>
                    </thead><tbody>
                        {this.state.deviceProvisioningSteps.map(step =>
                            <DescriptionAndFix key={step.stepNumber} description={step.description} status={step.status} fix={this.state.fix} onClick={this.openHelpModal} stepNumber={step.stepNumber} name={step.name} fixMessage={step.fixModal.message} fixTitle={step.fixModal.title} />
                        )}
                    </tbody>
                 </table>
                {fixContents}</div>

        if (this.props.currentCustomerId === -1) {
            return (
                <div>
                    <p className="status-msg">No customer selected. Please select a customer to view provisioning information.</p>
                </div>
            );
        }
        
        let gatewayButton = this.props.isModal ?
            null
            : <div>
                <button
                    type="button"
                    className="gatewaybtn-right secondary-btn btn-small"
                    onClick={() => this.openGatewayModal()}
                >
                    Open Gateway Workflow...
                </button>
            </div>;
        
        return (
            <div className="edit-form">
                <div className="white-container">
                    <div className="form">

                        <h6 className="sectionTitle" >Select Source for Asset Provisioning</h6>
                        <div className="radio-group">
                            <label className="col-md-5 col-lg-4 px-3 max-width-250" ><input type="radio" disabled className="q1 col-3 display-none" value="q10" id="q10" checked={false}  />HVAC System</label>
                            <SelectHVACSystem hvacList={this.state.hvacList} onChange={this.onHVACSelect} radio={this.state.radio} techStr={this.state.currentInstallTechStr} />
                            <br />
                            <label className="col-md-5 col-lg-4 px-1 max-width-250" ><input type="radio" className="q1 col-3" value="q11" id="q11" checked={this.state.radio === 0} onChange={this.changeRadio.bind(this, 0)} />User Device</label>
                            <SelectDevice deviceList={this.state.deviceList} onChange={this.onDeviceSelect} radio={this.state.radio} />
                            <br />
                            <label className="col-md-5 col-lg-4 px-1 max-width-250" ><input type="radio" className="q1 col-3" value="q12" id="q12" checked={this.state.radio === 1} onChange={this.changeRadio.bind(this, 1)} />Unassigned Devices</label>
                            <SelectUnparentedAsset unparentedAssets={unparentedAssets} onChange={this.onUnparentedAssetSelect} radio={this.state.radio} />
                            <br />

                            <label className="col-md-5 col-lg-4 px-1 max-width-250" ><input type="radio" className="q1 col-3" value="q13" id="q13" checked={this.state.radio === 2} onChange={this.changeRadio.bind(this, 2)} />Ad hoc MAC</label>
                            <input
                                type="text"
                                className="selectpicker col-sm-7 col-md-6 col-lg-5 input-adhoc-mac"
                                id="adHocMac"
                                placeholder="Type here..."
                                onChange={this.onChangeadHocMacId}
                                value={this.state.adHocMacId}
                                disabled={this.state.radio === 2 ? false : true}
                            />
                            <button
                                type="button"
                                className="gatewaybtn-right secondary-btn btn-small"
                                onClick={() => {this.runProvisionTest()}}
                            >
                                Run Provision Test
                            </button>

                            <br />
                            <div className="margin-left-25">
                                <label ref={this.deviceSelectErrorRef}></label>
                            </div>
                        </div>
                    </div>
                </div>
                <br /> 
                <form>
                    <div className="table-container">
                        {tableContents}
                    </div>
                </form>
                {gatewayButton}
                <div>
                    {this.props.isModal ? null : <ProvisioningStatusHistory data={this.state.provisioningHistoryStatus} selectedPage={this.state.defaultpage} getprovisionHistory = {this.provisioningHistoryStatus} />}
                </div>

                <GatewayWorkflowModal backdrop="static" onClick={this.showGatewayModal} show={this.state.showGateway}>
                </GatewayWorkflowModal>

                <HelpModal onClick={this.showHelpModal} show={this.state.showHelp} ModalTitle={this.state.ModalTitle} ModalMessage={this.state.ModalMessage} />

            </div >
        );

    }

    render() {
        const { classes } = this.props;
        
        let notPartnerAdminMsg = <div className="margin-left-10">
            <br />
            <h5>Must be a Admin to access this page!</h5>
        </div>;
        
        let contents = this.state.loading
            ? (this.props.isModal ? <FullLoader /> : <Loader />)
            : (this.props.roles.includes("ADMIN")  ?
                this.renderAssets(this.state.homeList, this.state.unparentedAssets, this.state.deviceList, this.props.currentCustomerId)
                : notPartnerAdminMsg
            );

        let pageTitle = this.props.isModal ? null : <h3 className="pageTitle">Provisioning</h3>;
        return (
            <div sx={(theme)=>({
                [theme.breakpoints.down('md')]: {
                    marginLeft: this.props.isModal ? 'unset' : '-225px !important',
                },
            })}>
                <div className={this.props.isModal ? '' : 'infoPage'}>
                    {pageTitle}
                    {contents}
                </div>
            </div>
        );
    }
}

class SelectUnparentedAsset extends React.Component {
    render() {
        if (this.props.unparentedAssets != null) {
            return (
                <select  className="selectpicker col-sm-7 col-md-6 col-lg-5 max-width-250" value={this.props.organizationId} onChange={this.props.onChange} disabled={this.props.radio === 1 ? false : true}>
                    {this.props.unparentedAssets.map((obj, index) =>
                        <option key={`${index}-${obj.assetId}`} id={`${index}-${obj.orgId}`} value={index}>{obj.name}</option>
                    )}
                </select>

            );
        }
        else {
            return (null);
        }
    }
}

class SelectDevice extends React.Component {
    render() {

        if (this.props.deviceList != null) {

            return (

                <select  className="selectpicker col-sm-7 col-md-6 col-lg-5 max-width-250" value={this.props.currentCustomerId} onChange={this.props.onChange} disabled={this.props.radio === 0 ? false : true}>
                    {this.props.deviceList.map((obj, index) =>
                        <option key={`${index}-${obj.assetId}`} id={`${index}-${obj.assetId}`} value={index}>{obj.mac}</option>
                    )}
                </select>

            );
            
        }
        else {
            return (null);
        }
    }
}

class SelectHVACSystem extends React.Component {
    getPrettyName(name) {
        if (name !== null && name !== undefined) {

            var split = name.split("__");
            return split[0];
        }
        else {
            return "";
        }
    }

    render() {
        if (this.props.hvacList != null) {
            let techInfo = this.props.techStr !== "" && this.props.techStr !== null && this.props.techStr !== undefined ?
                <span className="installed-by" >Installed By: {this.props.techStr}</span>
                : null;
            return (<span>
                <select className="selectpicker col-sm-7 col-md-6 col-lg-5 max-width-250"  value={this.props.houseAssetId} onChange={this.props.onChange}>
                    {this.props.hvacList.map((obj, index) =>
                        <option key={`${index}-${obj.assetId}`} id={`${index}-${obj.assetId}`} value={index}>{this.getPrettyName(obj.name)}</option>
                    )}
                </select>
                {techInfo}
            </span>
            );
        }
        else {
            return (null);
        }
    }
}

class SelectStatusIcon extends React.Component {
    render() {

        if (this.props.status === 1) {
            return (
                <CircleIcon className={"pad-5 color-green"} />
                );
        }
        else if (this.props.status === -1) {
            return (
                <CircleIcon className={"pad-5 color-red"} />
                );
        }
        else if (this.props.status === 2) {
            return (
                <CircleIcon className={"pad-5 color-grey"} />
            );
        }
        else {
            return (
                <CircleIcon className={"pad-5 color-yellow"} />
                );
        }
    }
}

export class DescriptionAndFix extends React.Component {
    render() {
        return (
            <tr key={this.props.stepNumber}>
                <td>{this.props.stepNumber}</td>
                <td className="text-center"><SelectStatusIcon status={this.props.status} /></td>
                <td>{this.props.name}</td>
                <td>
                    {this.props.description}
                </td>
                <td>
                    <button
                        type="button"
                        className="primary-btn btn-small"
                        onClick={() => { this.props.onClick(this.props.fixTitle, this.props.fixMessage) }}
                        style={{ marginLeft: 10 + 'px', display: this.props.status !== -1 ? 'none' : 'block' }}
                    >
                        Fix
                    </button>
                </td>
            </tr>   
        );  
    }
}

export default Provisioning;